import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenClaimDataStep } from 'store/modules/openClaim/actions';
import { ApplicationState } from 'store/store.inteface';

export default function useModalSaveDraft(step: string) {
  const stateClaim = useSelector((state: ApplicationState) => state.openClaim);

  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [dispatched, setDispatched] = useState(false);

  const [savingDraft, setSavingDraft] = useState(false);

  const [stateModal, setStateModal] = useState({
    display: 1, // 1 = inicial, 2 = ok, 3 = erro
    errorMessage: '',
  });

  const onClickForward = (data: any) => {
    if (!savingDraft) {
      setSavingDraft(true);
      dispatch(setOpenClaimDataStep(data, step, 'forward'));
    }
  };

  const saveDraftAndLeave = (data: any) => {
    dispatch(setOpenClaimDataStep(data, step, 'stay'));
    setDispatched(true);
  };

  const onClickCancel = () => {
    setOpenModal(true);
  };

  const onError = () => {
    setStateModal({
      ...stateModal,
      display: 3,
      errorMessage: 'Campo(s) inválido(s)',
    });
  };

  useEffect(() => {
    if (dispatched && stateClaim.successDraft)
      setStateModal({
        ...stateModal,
        display: 2,
      });
  }, [dispatched, stateClaim.successDraft]);

  useEffect(() => {
    if (savingDraft && (stateClaim.successDraft || stateClaim.errorDraft)) {
      setSavingDraft(false);
    }
  }, [savingDraft, stateClaim.successDraft, stateClaim.errorDraft]);

  return {
    openModal,
    setOpenModal,
    stateModal,
    setStateModal,
    onClickForward,
    saveDraftAndLeave,
    onClickCancel,
    onError,
    savingDraft,
    setSavingDraft,
  };
}
